import Section from './WorkOrderSection'
import isEmpty from './WorkOrderIsEmpty'

export default { isEmpty, Section }
